import { useCallback, useMemo, useRef, useState } from "react";
import AsyncSelect from "react-select/async";
import { searchEmployees } from "../../Moduels/attendance/rosterApi";
import { employeeLabel } from "./rosterUtils";

const PAGE_SIZE = 50;

function VirtualMenuList(props) {
  const { children, maxHeight } = props;
  const items = Array.isArray(children) ? children : children ? [children] : [];
  const [scrollTop, setScrollTop] = useState(0);
  const rowHeight = 52;
  const visible = Math.ceil(maxHeight / rowHeight) + 4;
  const start = Math.max(0, Math.floor(scrollTop / rowHeight) - 2);
  const end = Math.min(items.length, start + visible);
  const slice = items.slice(start, end);
  const totalHeight = items.length * rowHeight;

  return (
    <div
      style={{ maxHeight, overflow: "auto" }}
      onScroll={(e) => setScrollTop(e.target.scrollTop)}
    >
      <div style={{ height: totalHeight, position: "relative" }}>
        <div style={{ position: "absolute", top: start * rowHeight, left: 0, right: 0 }}>
          {slice}
        </div>
      </div>
    </div>
  );
}

export default function WfEmployeeSelect({ value, onChange, activeOnly = true, disabled, placeholder }) {
  const debounceRef = useRef(null);

  const loadOptions = useCallback(
    (inputValue) =>
      new Promise((resolve) => {
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(async () => {
          try {
            const data = await searchEmployees({
              search: inputValue,
              page: 1,
              pageSize: PAGE_SIZE,
              activeOnly,
            });
            const items = Array.isArray(data?.items)
              ? data.items
              : Array.isArray(data)
                ? data
                : [];
            resolve(
              items.map((emp) => {
                const { primary, secondary } = employeeLabel(emp);
                return {
                  value: emp.employee_id,
                  label: primary,
                  meta: secondary,
                  raw: emp,
                };
              })
            );
          } catch {
            resolve([]);
          }
        }, 300);
      }),
    [activeOnly]
  );

  const selected = useMemo(() => {
    if (!value) return null;
    if (typeof value === "object" && value.value) return value;
    return { value, label: "Selected employee" };
  }, [value]);

  const formatOptionLabel = (opt) => (
    <div>
      <div className="text-sm font-medium text-gray-900">{opt.label}</div>
      {opt.meta && <div className="text-xs text-gray-500">{opt.meta}</div>}
    </div>
  );

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions
      loadOptions={loadOptions}
      value={selected}
      onChange={(opt) => {
        const id = opt?.raw?.employee_id ?? opt?.value ?? "";
        onChange(id ? String(id) : "", opt?.raw);
      }}
      isDisabled={disabled}
      placeholder={placeholder || "Search employee code or name…"}
      formatOptionLabel={formatOptionLabel}
      components={{ MenuList: VirtualMenuList }}
      classNamePrefix="wf-select"
      styles={{
        control: (base) => ({
          ...base,
          minHeight: 42,
          borderRadius: 8,
          borderColor: "#d1d5db",
        }),
      }}
      noOptionsMessage={() => "No employees found"}
    />
  );
}
